import { Preferences } from '@capacitor/preferences'

/**
 * The Preferences API provides a simple key/value persistent store for lightweight data.
 * Mobile OSs may periodically clear data set in window.localStorage, so this API should be used instead.
 * This API will fall back to using localStorage when running as a Progressive Web App.
* */

const buildKey = (prefix, key) => {
    return `${prefix}:${key}`
}

export const filterPreferences = {

    async getEnabledFilters(prefix, key, defaultValue = []) {
        const data = await Preferences.get({ key: buildKey(prefix, key) })
        return data.value ? JSON.parse(data.value) : defaultValue
    },

    async setEnabledFilters(prefix, key, filters) {
        const value = JSON.stringify(filters)
        await Preferences.set({
            key: buildKey(prefix, key),
            value,
        })
    },
}
